import { addDataSource, editDataSource, dataSourceDetail } from './request';
export default {
  data() {
    return {
      dialogVisible: false,
      dataFrom: {}
    };
  },
  computed: {
    dataRule() {
      return {
        name: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('数据源名称')
        }],
        mark: [{
          required: true,
          trigger: 'blur',
          message: this.$t('请输入') + this.$t('标识')
        }]
      };
    }
  },
  methods: {
    async init(val) {
      this.dialogVisible = true;
      if (val) {
        const res = await dataSourceDetail({
          sourceId: val.id
        });
        this.dataFrom = {
          sourceId: res.id,
          name: res.name,
          mark: res.mark
        };
      }
    },
    handleSure() {
      this.$refs.dataFrom.validate(async valid => {
        if (valid) {
          const FUN = this.dataFrom.sourceId ? editDataSource : addDataSource;
          await FUN(this.dataFrom);
          this.$message.success(this.$t('操作成功'));
          this.$emit('save');
          this.$emit('cancel');
        }
      });
    }
  }
};